import { render, staticRenderFns } from "./TennisRankPage.vue?vue&type=template&id=5fc79355&scoped=true&"
import script from "./TennisRankPage.vue?vue&type=script&lang=js&"
export * from "./TennisRankPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc79355",
  null
  
)

export default component.exports